import { Language } from 'common/helpers/language'
import { CreatedFrom } from 'modules/transmission/types'

export const SOURCE_BY_LIVE_ORING = {
  [CreatedFrom.CLUB]: 'Club',
  [CreatedFrom.ONLINE_EVENT]: 'OnlineEvent',
  [CreatedFrom.ON_FIRE]: 'OnlineEvent',
  [CreatedFrom.WEBINAR]: 'Webinar',
  [CreatedFrom.SPARKLE]: 'Sparkle'
}

export const HOTJAR_LANGUAGE: {[language in Language]: string} = {
  [Language.AR]: 'AR',
  [Language.EN]: 'EN',
  [Language.ES]: 'ES',
  [Language.FR]: 'FR',
  [Language.PT]: 'PT'
}
